// extracted by mini-css-extract-plugin
export default {"headerBox":"TextAreaBox_headerBox__Hq1r6","header":"TextAreaBox_header__h7TpW","inputBox":"TextAreaBox_inputBox__VIWeT"};